export const THEME_NAME = {
  LIGHT: 'light',
  DARK: 'dark',
};

export const APP_THEME_NAME = {
  FUSION_MARKETS: 'FUSION_MARKETS',
  FMGP: 'FMGP',
};
